module.exports = __webpack_public_path__ + "static/media/rating.15515719.svg";